export default "__VITE_ASSET__DROgMWHi__"